module.exports = __webpack_public_path__ + "img/flutter.3351c0b9.svg";